import { filingGuidance } from "@/lib/guidance";
import { missingItems } from "@/lib/compliance";

export const driverComplete = (d) => {
  const ec = d.emergency_contact || {};
  return !!(d.name?.trim() && d.driver_type && ec.name?.trim() && ec.phone?.trim());
};

export function complianceProgress(profile, records) {
  const guide = filingGuidance(profile);
  const filings = (profile.filings || []).filter((f) => f.key !== "drug_testing" && (guide[f.key]?.status || "required") !== "not_required");
  const docs = missingItems(profile, records);
  const drivers = profile.drivers || [];
  const parts = [
    { key: "filings", label: "Filings", done: filings.filter((f) => f.status === "completed").length, total: filings.length, to: "#filings",
      missing: filings.filter((f) => f.status !== "completed").map((f) => f.label || f.key) },
    { key: "documents", label: "Documents & dates", done: docs.total - docs.missing.length, total: docs.total, to: "/compliance",
      missing: docs.missing.map((m) => m.notifyLabel || m.label) },
    { key: "drivers", label: "Driver profiles", done: drivers.filter(driverComplete).length, total: Math.max(drivers.length, 1), to: "/wizard",
      hint: drivers.length ? null : "Add at least one driver",
      missing: drivers.length ? drivers.filter((d) => !driverComplete(d)).map((d, i) => `Finish driver profile: ${d.name || `Driver ${i + 1}`} (type + emergency contact)`) : ["Add at least one driver profile"] },
  ];
  const done = parts.reduce((a, p) => a + p.done, 0);
  const total = parts.reduce((a, p) => a + p.total, 0);
  return { parts, done, total, pct: total ? Math.round((done / total) * 100) : 0 };
}
